import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Heart, Mail, Phone, Download, RefreshCw } from 'lucide-react';
import { exportToCSV, formatDate } from '../../lib/admin/utils';

const WeddingsTab = ({ weddingBookings, loading, onRefresh }) => (
  <div className="space-y-4">
    <div className="flex justify-between items-center">
      <h2 className="text-xl font-semibold text-gray-900">Wedding Bookings</h2>
      <div className="flex gap-2">
        <Button onClick={onRefresh} variant="outline" size="sm">
          <RefreshCw className="w-4 h-4 mr-2" />
          Refresh
        </Button>
        <Button
          onClick={() => exportToCSV(weddingBookings, 'wedding-bookings')}
          className="bg-[#FDB913] hover:bg-[#E5A50A] text-gray-900"
          size="sm"
        >
          <Download className="w-4 h-4 mr-2" />
          Export CSV
        </Button>
      </div>
    </div>

    {loading ? (
      <div className="text-center py-12">Loading...</div>
    ) : weddingBookings.length === 0 ? (
      <Card>
        <CardContent className="py-12 text-center text-gray-500">No wedding bookings yet</CardContent>
      </Card>
    ) : (
      <div className="space-y-4">
        {weddingBookings.map((wedding) => (
          <Card
            key={wedding._id || `${wedding.email}-${wedding.createdAt}`}
            className="hover:shadow-lg transition-shadow border-l-4 border-l-[#FDB913]"
          >
            <CardContent className="pt-6">
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <div className="flex items-center gap-2 mb-3">
                    <Heart className="w-5 h-5 text-[#FDB913]" />
                    <span className="font-semibold text-lg">
                      {wedding.firstName} {wedding.lastName}
                    </span>
                    {wedding.emailSent && (
                      <Badge className="bg-green-100 text-green-800">PDF Sent</Badge>
                    )}
                  </div>
                  <div className="space-y-2 text-sm">
                    <div className="flex items-center gap-2">
                      <Mail className="w-4 h-4 text-gray-500" />
                      <a href={`mailto:${wedding.email}`} className="text-blue-600 hover:underline">{wedding.email}</a>
                    </div>
                    <div className="flex items-center gap-2">
                      <Phone className="w-4 h-4 text-gray-500" />
                      <a href={`tel:${wedding.phone}`} className="text-blue-600 hover:underline">{wedding.phone}</a>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="space-y-2 text-sm">
                    <div><span className="font-semibold">Wedding Date:</span> {wedding.weddingDate}</div>
                    <div><span className="font-semibold">Guest Count:</span> {wedding.guestCount}</div>
                    {wedding.message && (
                      <div>
                        <span className="font-semibold">Message:</span>
                        <p className="text-gray-600 mt-1">{wedding.message}</p>
                      </div>
                    )}
                    <div className="text-xs text-gray-500 mt-2">Booked: {formatDate(wedding.createdAt)}</div>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    )}
  </div>
);

export default WeddingsTab;
